import { render, staticRenderFns } from "./ListCoins.vue?vue&type=template&id=ed68c1d6"
import script from "./ListCoins.vue?vue&type=script&lang=js"
export * from "./ListCoins.vue?vue&type=script&lang=js"
import style0 from "./ListCoins.vue?vue&type=style&index=0&id=ed68c1d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports